import { buildCrudRoutes } from '@/app/arch/components/crud/CrudRouter';
import moduleBreadcrumbs from '../../moduleBreadcrumbs';

export default [
  ...buildCrudRoutes({
    baseName: 'statements',
    basePath: 'statement',
    baseBreadcrumbs: [
      ...moduleBreadcrumbs,
      {
        text: 'Listar transações',
        disabled: true,
      },
    ],
    card: {
      title: 'Transações',
      icon: 'home',
    },
    moduleActive: 'contacard',
    subModuleActive: 'reports',
    listRoute: {
      pageContent: () => import('Modules/contacard/reports/statements/StatementsCrudList.vue'),
      reportComponent: () => import('Modules/contacard/reports/statements/components/StatementTerminateBtn.vue'),
      filterComponent: () => import('Modules/contacard/reports/statements/components/StatementFilter.vue'),
      speedFilter: () => import('Modules/contacard/reports/statements/components/StatemmentSpeedFilter.vue'),
      searchComponent: () => import('Arch/components/crud/components/OnlySearchFilter.vue'),
      searchOptions: { label: 'Buscar transação', searchAttribute: 'search' },
      pageTitle: 'Listar transações',
      navigateBackRoute: 'contacard.submodules.list',
    },
  }),
];
